import notify from "./notify";
import token from "./token";

export default {
  notify: notify,
  token: token,
};
